import { CLIENT_BROKER_VALIDATION_RULES } from "./clientBrokerValidationRules";

import { MAX_DECIMAL } from "../../common/Configurations/DecimalConfiguration";
import { AUTOMATIC } from "./enums/automaticMemberIdentifierOptions";
import { TED_DESJARDINS } from "./enums/synchronizationOptions";

export const CLIENTS_VALIDATION_RULES = {
  coverageWebsite: {
    regex: {
      value: {
        pattern: /^$|http(s)?:\/\/[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&'\(\)\*\+,;=.]+$/i,
        customMessageKey: "validation.websiteRegex",
      },
    },
  },
  isAutomaticMemberIdentifier: {
    isRequiredTrim: {
      value: true,
    },
    fieldMustHaveValueIfOtherValueSelected: {
      value: {
        otherValueKey: "syncType",
        otherExpectedValue: TED_DESJARDINS.value,
        expectedFieldValue: AUTOMATIC.value,
        customMessageKey: "validation.clientFieldValidation.tedDesjardinsValidationMemberConfig"
      }
    }
  },
  acombaNumber: {
    regex: {
      value: {
        pattern: /^\d*$/,
        customMessageKey: "validation.customMessages.numeric",
      },
    },
    maxLength: {
      value: 8,
    },
  },
  acombaProjectNumber: {
    regex: {
      value: {
        pattern: /^[a-zA-Z0-9]*$/,
        customMessageKey: "validation.customMessages.alphanumeric",
      },
    },
    maxLength: {
      value: 15,
    },
  },
  name: {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 128,
    },
  },
  fullName: {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 128,
    },
  },
  designator: {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 8,
    },
  },
  blocId: {
    isRequiredTrim: {
      value: true,
    },
  },
  businessAccountType: {
    isRequiredTrim: {
      value: true,
    },
  },
  syncType: {
    isRequiredTrim: {
      value: true,
    },
  },
  clientBillingPeriodType: {
    isRequiredTrim: {
      value: true,
    },
  },

  address: {
    isRequiredTrim: {
      value: true,
    },
  },
  city: {
    isRequiredTrim: {
      value: true,
    },
  },
  countryCode: {
    isRequiredTrim: {
      value: true,
    },
  },
  provinceCode: {
    isRequiredTrim: {
      value: true,
    },
  },
  postalCode: {
    isRequiredTrim: {
      value: true,
    },
  },
  majorFixedFee: {
    minValue: {
      value: 0,
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  majorVariableFee: {
    minValue: {
      value: 0,
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  ...CLIENT_BROKER_VALIDATION_RULES,
};


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/clientValidationRules.js